import { render } from "./Autocomplete.vue?vue&type=template&id=fb35151a&ts=true"
import script from "./Autocomplete.vue?vue&type=script&lang=ts"
export * from "./Autocomplete.vue?vue&type=script&lang=ts"

import "./Autocomplete.vue?vue&type=style&index=0&id=fb35151a&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__